import { Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { OrderService } from '@api-services';
import { AuthenticationService } from '@services';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'wun-orders',
  standalone: true,
  imports: [CurrencyPipe, DatePipe, RouterLink, TranslocoDirective],
  templateUrl: './orders.component.html',
  styleUrl: './orders.component.scss'
})
export class OrdersComponent {
  private readonly orderService = inject(OrderService);
  private readonly authService = inject(AuthenticationService);

  orders = rxResource({
    params: () => this.authService.current(),
    stream: params => this.orderService.ordersFindAndPaginate({
      filters: JSON.stringify({ user: params.params.id }),
      includes: JSON.stringify(['rows.artwork.mainAttachment', 'address']),
      sorting: JSON.stringify({ createdAt: 'DESC' })
    })
  });

  statusClass(status: string): string {
    const map: Record<string, string> = {
      CREATED: 'bg-yellow-100 text-yellow-700',
      PAYED: 'bg-blue-100 text-blue-700',
      PAID: 'bg-blue-100 text-blue-700',
      SHIPPED: 'bg-purple-100 text-purple-700',
      DELIVERED: 'bg-green-100 text-green-700',
    };
    return map[status] ?? 'bg-gray-100 text-gray-700';
  }
}
